import { FC, useState } from "react";
import { Box, Modal, useTheme } from "@mui/material";

import { PricingPlansOnboardingRoute } from "../PricingPlansOnboardingRoute";
import { BG_COLORS } from "../../../../constants";
import { useAppSelector } from "../../../../store/hooks";
import { ExtensionPromotionOnboardingRoute } from "../ExtensionPromotionOnboardingRoute";

const routes: FC[] = [
  // PricingPlansOnboardingRoute,
  ExtensionPromotionOnboardingRoute,
];

export const OnboardingModal = () => {
  const [index] = useState(0);

  const { isActive } = useAppSelector((state) => state.onboarding);

  const theme = useTheme();

  const Route = routes[index];
  const zIndex = Math.max(...Object.values(theme.zIndex)) + 2;

  return (
    <Modal
      open={isActive}
      sx={{ zIndex, overflow: "auto" }}
      tabIndex={-1}
      disableAutoFocus
    >
      <Box width="100%" minHeight="100dvh" bgcolor={BG_COLORS.default}>
        <Route />
      </Box>
    </Modal>
  );
};
